// أعلام المزايا من الخادم (زمن تشغيل) — المعاينة مفعّلة، والمباشر معطل افتراضيًا
// حتى اعتماد كل ميزة. القيمة الافتراضية قبل الجلب: معطل.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let flags = { vouchers: false, offersV2: false };
let loaded = false;
const listeners = new Set();

export const loadFeatureFlags = () => {
  if (loaded) return Promise.resolve(flags);
  loaded = true;
  return api.get("/feature-flags")
    .then(({ data }) => { flags = { vouchers: !!data.vouchers, offersV2: !!data.offersV2 }; listeners.forEach((fn) => fn()); })
    .catch(() => {});
};

export const getFlags = () => flags;
export const onFlagsLoaded = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export const useFeatureFlags = () => {
  const [f, setF] = useState(flags);
  useEffect(() => {
    loadFeatureFlags();
    return onFlagsLoaded(() => setF({ ...flags }));
  }, []);
  return f;
};
